import React from "react";
import styles from "../centromedicodonavitta_/servicos_centromedicodonavitta_.module.scss";
import {
    Stethoscope,
    Baby,
    Scissors,
    Zap,
    Activity,
    ArrowLeft,
    ScanLine,
    HeartPulse,
} from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const whatsappLink = (servico: string) =>
    `https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de saber mais sobre ${encodeURIComponent(
        servico
    )} na Dona Vitta`;

const Servicos_centromedicodonavitta_: React.FC = () => {
    return (
        <div className={styles.servicos_centromedicodonavitta_}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/centromedicodonavitta_" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Nossos Serviços</h1>
            </div>

            {/* Serviços */}
            <div className={styles.services}>
                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Consultas com Obstetra</h3>
                    <a href={whatsappLink("Consultas com Obstetra")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Stethoscope className={styles.icon} />
                    <h3>Consultas com Ginecologista</h3>
                    <a href={whatsappLink("Consultas com Ginecologista")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Iniciar Pré-natal</h3>
                    <a href={whatsappLink("Iniciar Pré-natal")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Stethoscope className={styles.icon} />
                    <h3>Consulta com Urologista</h3>
                    <a href={whatsappLink("Consulta com Urologista")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Scissors className={styles.icon} />
                    <h3>Cirurgia Íntima</h3>
                    <a href={whatsappLink("Cirurgia Íntima")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Partos</h3>
                    <a href={whatsappLink("Partos")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Zap className={styles.icon} />
                    <h3>Laser em Ginecologia</h3>
                    <a href={whatsappLink("Laser em Ginecologia")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <ScanLine className={styles.icon} />
                    <h3>Ultrassom Obstétrico e Morfológico</h3>
                    <a href={whatsappLink("Ultrassom Obstétrico e Morfológico")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <ScanLine className={styles.icon} />
                    <h3>Ultrassom na Saúde da Mulher</h3>
                    <a href={whatsappLink("Ultrassom na Saúde da Mulher")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <HeartPulse className={styles.icon} />
                    <h3>Ecocardiograma Fetal</h3>
                    <a href={whatsappLink("Ecocardiograma Fetal")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <HeartPulse className={styles.icon} />
                    <h3>Ecocardiograma Pediátrico</h3>
                    <a href={whatsappLink("Ecocardiograma Pediátrico")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Activity className={styles.icon} />
                    <h3>Fisioterapia Pélvica</h3>
                    <a href={whatsappLink("Fisioterapia Pélvica")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dona Vitta • Centro Médico da Mulher
                </p>
                <p className={styles.footerSubtitle}>
                    Seja Dona • Seja Vitta
                </p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/centromedicodonavitta_?igsh=Y2t6Z2hseWVpZDQ1"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#456345" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/i5ygw1tv3QZEUeq88"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#456345" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_centromedicodonavitta_;
